import { render, staticRenderFns } from "./CardAnalyticsCustomer.vue?vue&type=template&id=5194f396&scoped=true"
import script from "./CardAnalyticsCustomer.vue?vue&type=script&lang=js"
export * from "./CardAnalyticsCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194f396",
  null
  
)

export default component.exports